var exports = {
  "k": "xe533113f--420b0a--container",
  "u": "xe533113f--420b0a--spinner",
};

module.exports = exports;
